import { Sprite } from "@pixi/sprite";
import { Texture } from "@pixi/core";
import { PieceColor } from "../../../enums/PieceColor";
import { TriangleRotationStatus } from "../../../enums/TriangleRotationStatus";
import { GameUIResourcesPackage } from "../../../../preloader/resources/GameUIResourcesPackage";
import { Spine } from "pixi-spine";

export class TriangleView extends Sprite {
    public constructor(
        texture: Texture,
        private readonly resources: GameUIResourcesPackage,
        private readonly color: PieceColor,
        private readonly rotationStatus: TriangleRotationStatus
    ) {
        super(texture);
    }
    
    public get Color(): PieceColor {
        return this.color;
    }

    public get RotationStatus(): TriangleRotationStatus {
        return this.rotationStatus;
    }

    public async createAnimation(): Promise<void> {
        return new Promise(async (resolve) => {
            const effect = new Spine((this.resources.assets_game_effects_triangles_appearance_destroy_json as any).spineData);
            let animationName = "appearance";
            switch (this.RotationStatus) {
                case TriangleRotationStatus.BOTTOM_LEFT: {
                    animationName += "_bottom_left";
                    break;
                }
                case TriangleRotationStatus.BOTTOM_RIGHT: {
                    animationName += "_bottom_right";
                    break;
                }
                case TriangleRotationStatus.TOP_LEFT: {
                    animationName += "_top_left";
                    break;
                }
                case TriangleRotationStatus.TOP_RIGHT: {
                    animationName += "_top_right";
                    break;
                }
                default: {
                    throw new Error("CellView.destroyTriangle: unknown triangle rotation status!");
                }
            }
            effect.state.setAnimation(0, animationName, false).timeScale = 1.3;
            this.addChild(effect);
            effect.state.addListener({
                complete: () => {
                    requestAnimationFrame(() => {
                        this.removeChild(effect).destroy({ children: true });
                        resolve();
                    });
                }
            });
        });
    }

    public async destroyAnimation(): Promise<void> {
        return new Promise(async (resolve) => {
            const effect = new Spine((this.resources.assets_game_effects_triangles_appearance_destroy_json as any).spineData);
            let animationName = "destroy";
            switch (this.RotationStatus) {
                case TriangleRotationStatus.BOTTOM_LEFT: {
                    animationName += "_bottom_left";
                    break;
                }
                case TriangleRotationStatus.BOTTOM_RIGHT: {
                    animationName += "_bottom_right";
                    break;
                }
                case TriangleRotationStatus.TOP_LEFT: {
                    animationName += "_top_left";
                    break;
                }
                case TriangleRotationStatus.TOP_RIGHT: {
                    animationName += "_top_right";
                    break;
                }
                default: {
                    throw new Error("TriangleView.destroyTriangle: unknown triangle rotation status!");
                }
            }
            effect.state.setAnimation(0, animationName, false).timeScale = 1.3;
            this.addChild(effect);
            effect.state.addListener({
                complete: () => {
                    requestAnimationFrame(() => {
                        this.removeChild(effect).destroy({ children: true });
                        resolve();
                    });
                }
            });
        });
    }

    public playUltimateAnimation(): void {
        const effect = new Spine((this.resources.assets_game_effects_triangles_appearance_destroy_json as any).spineData);
        let animationName = "u_f_animation_blik";
        switch (this.RotationStatus) {
            case TriangleRotationStatus.BOTTOM_LEFT: {
                animationName += "_bottom_left";
                break;
            }
            case TriangleRotationStatus.BOTTOM_RIGHT: {
                animationName += "_bottom_right";
                break;
            }
            case TriangleRotationStatus.TOP_LEFT: {
                animationName += "_top_left";
                break;
            }
            case TriangleRotationStatus.TOP_RIGHT: {
                animationName += "_top_right";
                break;
            }
            default: {
                throw new Error("UltimateFigure.destroyTriangle: unknown triangle rotation status!");
            }
        }
        effect.state.setAnimation(0, animationName, true);
        this.addChild(effect);
    }

    public async deckSpawnAnimation(): Promise<void> {
        return new Promise(async (resolve) => {
            const effect = new Spine((this.resources.assets_game_effects_triangles_appearance_destroy_json as any).spineData);
            let animationName = "deck_appearence";
            switch (this.RotationStatus) {
                case TriangleRotationStatus.BOTTOM_LEFT: {
                    animationName += "_bottom_left";
                    break;
                }
                case TriangleRotationStatus.BOTTOM_RIGHT: {
                    animationName += "_bottom_right";
                    break;
                }
                case TriangleRotationStatus.TOP_LEFT: {
                    animationName += "_top_left";
                    break;
                }
                case TriangleRotationStatus.TOP_RIGHT: {
                    animationName += "_top_right";
                    break;
                }
                default: {
                    throw new Error("TriangleView.deckSpawnAnimation: unknown triangle rotation status!");
                }
            }
            effect.state.setAnimation(0, animationName, false);
            this.addChild(effect);
            effect.state.addListener({
                complete: () => {
                    requestAnimationFrame(() => {
                        this.removeChild(effect).destroy({ children: true });
                        resolve();
                    });
                }
            });
        });
    }
}